// extracted by mini-css-extract-plugin
module.exports = {"error":"EditInPlace__error__5MQKU"};